import {useCallback, useState} from 'react';

/**
 * Manages dropdown menu position and open/close state.
 * @returns {{ menuOpen, dropdownPos, toggleMenu, setMenuOpen }}
 */
export default function useMenuPosition(btnRef) {
    const [menuOpen, setMenuOpen] = useState(false);
    const [dropdownPos, setDropdownPos] = useState({top: 0, right: 0});

    const toggleMenu = useCallback(() => {
        if (btnRef.current) {
            const rect = btnRef.current.getBoundingClientRect();
            setDropdownPos({top: rect.bottom + 4, right: window.innerWidth - rect.right});
        }
        setMenuOpen(o => !o);
    }, [btnRef]);

    return {menuOpen, dropdownPos, toggleMenu, setMenuOpen};
}
